<template>
    <b-nav-item-dropdown
        :variant="variant"
        :toggle-class="toggleClass"
        :no-caret="noCaret"
        :right="right"
        :text="menu.text"
    >
        <template v-slot:button-content v-if="menu.icon">
            <font-awesome-icon :icon="['fas', menu.icon]" :title="menu.text" size="lg"></font-awesome-icon>
            <span :class="{ 'sr-only': !menu.show_text }">{{ menu.text }}</span>
        </template>
        <li class="row">
            <ul v-for="(column, index) in menu.columns" :key="'ul' + index" class="col-lg list-unstyled">
                <b-dropdown-item
                    v-for="(item, index) in column.items"
                    :key="'bdi' + index"
                    :href="item.href"
                    :target="item.target"
                    @click="item.click != null ? onClick(item.click) : null"
                    v-bind:class="{ 'lx-header-dropdown-divider': item.divider }"
                >
                    <font-awesome-icon
                        v-if="item.icon"
                        :icon="[item.icon_prefix || 'fas', item.icon]"
                        :title="item.text"
                        size="lg"
                    ></font-awesome-icon>
                    <span>{{ item.text }}</span>
                </b-dropdown-item>
                <b-dropdown-group
                    v-for="(section, index) in column.sections"
                    :key="'bdg' + index"
                    :header="section.header"
                    class="lx-header-dropdown-group"
                >
                    <b-dropdown-item
                        v-for="(item, index) in section.items"
                        :key="'bdgi' + index"
                        :href="item.href"
                        :target="item.target"
                    >
                        <font-awesome-icon :icon="['fas', 'caret-right']" size="sm"></font-awesome-icon>
                        {{ item.text }}
                    </b-dropdown-item>
                </b-dropdown-group>
            </ul>
        </li>
    </b-nav-item-dropdown>
</template>

<script>
    export default {
        name: 'HeaderDropdown',
        props: {
            variant: String,
            toggleClass: String,
            noCaret: Boolean,
            right: Boolean,
            menu: Object,
        },
        methods: {
            onClick(event) {
                this.$event.$emit(event);
                // this.$bvModal.show()
            },
        },
        mounted: function () {
            this.$event.$on('print-calendar-modal', () => {
                this.$bvModal.show('print-calendar-modal');
            });
            this.$event.$on('create-property-modal', () => {
                this.$bvModal.show('create-property-modal');
            });
            this.$event.$on('create-dashboard-modal', () => {
                this.$bvModal.show('create-dashboard-modal');
            });
            this.$event.$on('team-member-module-error-moda', () => {
                this.$bvModal.show('team-member-module-error-modal');
            });
        },
        unmounted: function () {
            this.$event.$off('showPrintCalendarModal');
            this.$event.$off('showCreatePropertyModal');
            this.$event.$off('showCreateDashboardModal');
            this.$event.$off('showTeamMemberModuleErrorModal');
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .row {
        margin: 0;
    }

    @include media-breakpoint-down(md) {
        .dropdown {
            position: static;
        }

        :deep(.dropdown-menu) {
            width: calc(100vw - 2rem);
            overflow: hidden;
        }

        :deep(.dropdown-menu-right) {
            position: absolute !important;
            right: 0;
        }

        :deep(.dropdown-item) {
            max-width: calc(100vw - 3.5rem);
            overflow: hidden;
        }
    }

    @include media-breakpoint-up(lg) {
        .row {
            flex-wrap: nowrap;
        }

        :deep(.dropdown-menu) {
            max-height: 80vh;
            overflow: auto;
        }
    }

    .lx-header-dropdown-group {
        padding: 0 1rem;
    }

    .lx-header-dropdown-group :deep(.dropdown-item .fa-sm) {
        margin-right: 0.5rem;
        vertical-align: initial;
    }

    .lx-header-dropdown-divider {
        border-top: 1px solid #e0e0e0;
        margin-top: 10px;
        padding-top: 10px;
    }

    /*
      Overwriting bootstrap style
     */
    .col-lg {
        padding: 0;
    }

    :deep(.nav-link) {
        color: #ffffff !important;
    }

    :deep(.nav-link:hover, .nav-link:active) {
        color: rgba(255, 255, 255, 0.75) !important;
    }

    :deep(.dropdown-menu) {
        border-radius: 4px !important;
        padding: 0.5rem;
    }

    :deep(.dropdown-item) {
        padding: 0.5rem;
    }

    :deep(.dropdown-item:hover, .dropdown-item:active) {
        background-color: #4285f4;
        border-radius: 0.125rem;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
        box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
        color: #ffffff !important;
    }

    :deep(.dropdown-header) {
        margin-bottom: 1rem;
        border-bottom: 1px solid #e0e0e0;
        padding: 1rem 0 0.75rem 0;
        font-weight: 700;
        font-size: 1.1rem;
        text-transform: uppercase;
    }
</style>
